module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_BlackMatted.effbd386.jpg";